import { ListRange, SearchCriteriaBase } from '../../../../common/models';
import { DeliveryDeviation } from '../../../models';
import { Dimension } from '../../../models/monitoring-dimension';
import { ListQueryParam } from '../../../../common/constants';
import { TermsOfDelivery } from '../constants';
import { LatestNotification } from '../../monitoring/models';
import { MonitoringPageType } from '../../monitoring/constants';

export interface DeliveryNoteOverview {
  actualGoodsIssueDate: number;
  carrierId: string;
  carrierName: string;
  deliveryDeviation: DeliveryDeviation;
  deliveryNoteNumber: string;
  equipmentId: string;
  estimatedDeliveryDate: number;
  extNumber: string;
  forwarderTrackingNumber: string;
  hasDangerousGoods: boolean;
  incoterm1: TermsOfDelivery;
  incoterm2: string;
  latestNotification: LatestNotification;
  masterAirWaybillNumber: string;
  plannedGoodsIssueDate: number;
  plannedTimeArrivalDate: number;
  routeId: string;
  shipmentNumber: string;
  transportNumber: string;
}

export interface DeliveryNoteHandlingUnitModel {
  height: Dimension;
  huId: string;
  length: Dimension;
  barcodeId: string;
  packagingType: string;
  volume: Dimension;
  weight: Dimension;
  width: Dimension;
}

export class DeliveryNoteHandlingUnitSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.HandlingUnitIds]: string[] = [];
  [ListQueryParam.BoschMaterialNumbers]: string[] = [];
  [ListQueryParam.CustomerMaterialNumbers]: string[] = [];
  [ListQueryParam.BoschOrderNumbers]: string[] = [];
  [ListQueryParam.CustomerOrderNumbers]: string[] = [];

  constructor(params?: Partial<DeliveryNoteHandlingUnitSearchCriteria> | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export interface DeliveryNoteParams {
  deliveryNoteNumber: string;
  sapId: string;
  monitoringPageType?: MonitoringPageType;
}
